'use client';

import { Divider, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import { useState } from 'react';

import { ButtonWithIcon } from '@/components/buttons/buttonWithIcon';
import { CopyToClipboardWrapper } from '@/components/buttons/copyToClipboardButton';
import { MainDialog } from '@/components/dialogs/mainDialog';
import { TextDetailsTuple } from '@/components/text/textDetailsTuple';
import { useUser } from '@/contexts/useUser';

import pinkBackgroundSpaceship from '../../../../public/statics/images/illustrations/onboarding/pink_background_spaceship.png';

export const HelpButton = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  return (
    <>
      <ButtonWithIcon
        onClick={handleOpen}
        className='w-auto'
        text='Get Help'
        data-testid='get-help'
        icon='material-symbols-help-outline-rounded'
        sx={{
          color: 'white',
          '&:not(.Mui-disabled):hover': {
            color: 'white',
            backgroundColor: 'var(--mui-palette-primary-hover)',
          },
        }}
      />
      <GetHelpDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};

const GetHelpDialog = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { eonAccount } = useUser();
  const companyEmail = eonAccount?.companyContacts?.at(0)?.email;

  return (
    <MainDialog
      isOpen={open}
      isLoading={false}
      header={{ title: 'Get Help', onClose, hideBorder: true }}
    >
      <Stack gap='24px' margin='0 40px 40px 40px'>
        <Stack alignItems='center'>
          <Image
            alt='Get help'
            height={120}
            width={120}
            src={pinkBackgroundSpaceship}
          />
        </Stack>
        <Stack gap='24px' divider={<Divider sx={{ borderStyle: 'dashed' }} />}>
          {companyEmail && (
            <ContactRow
              title='Your company contact'
              description='Help with access, permissions, billing, and integrations.'
              email={companyEmail}
            />
          )}
          <ContactRow
            title='Eon support'
            description='Help with Eon features, support, planning, and product feedback.'
            email='support@eon.io'
          />
        </Stack>
      </Stack>
    </MainDialog>
  );
};

const ContactRow = ({
  title,
  description,
  email,
}: {
  title: string;
  description: string;
  email: string;
}) => {
  return (
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <TextDetailsTuple primaryProp={title} secondaryProp={description} />
      <CopyToClipboardWrapper textToCopy={email} showOnlyOnHover={false}>
        <Typography variant='body1'>{email}</Typography>
      </CopyToClipboardWrapper>
    </Stack>
  );
};
